import React, { useState, useEffect } from 'react';
import { Button, TextField, Paper, Typography, Box } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { auth } from '../../services/user-services';
import { useAuth } from '../../hooks/useAuth';
import { Link, useNavigate } from 'react-router-dom';

function Login() {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { authData, setAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authData) {
      navigate('/account');
    }
  }, [authData, navigate])

  const handleSubmit = async e => {
    e.preventDefault();
    const data = await auth({ username, password });
    setAuth(data);
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="70vh">
      {!authData &&
        <Paper elevation={0} sx={{ p: 4, borderRadius: 3, backgroundColor: 'background.paper', width: '100%', maxWidth: 400, border: '1px solid rgba(255,255,255,0.05)' }}>
          <Typography variant="h2" align="center" gutterBottom color="primary">
            Welcome Back
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" mb={4}>
            Login to access your groups
          </Typography>

          <form onSubmit={handleSubmit}>
            <Box mb={2}>
              <TextField
                fullWidth
                label="Username"
                variant="outlined"
                onChange={e => setUsername(e.target.value)}
                InputProps={{
                  startAdornment: <AccountCircleIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                }}
              />
            </Box>
            <Box mb={3}>
              <TextField
                fullWidth
                label="Password"
                type="password"
                variant="outlined"
                onChange={e => setPassword(e.target.value)}
                InputProps={{
                  startAdornment: <VpnKeyIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                }}
              />
            </Box>

            <Button fullWidth color="primary" variant="contained" type='submit' size="large" sx={{ mb: 2 }}>
              Login
            </Button>
          </form>

          <Box textAlign="center" mt={2}>
            <Link to={"/register"} style={{ color: '#ff9800', fontSize: '0.875rem' }}>
              Don't have an account? Register here
            </Link>
          </Box>
        </Paper>
      }
    </Box>
  );
}

export default Login;